import { Box } from '@material-ui/core';
import {
  Merchant,
  patchCreateSignatureReminderRequestForMerchantContract,
  patchCreateSignatureRequestForMerchantContract,
} from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { MerchantContractActionType } from '@/components/modules/MerchantDetail/MerchantCompliance/components/MerchantContract/types/MerchantContractActionType';
import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';

export const MerchantContractRelatedActionsDialog = ({
  merchantContractAction,
  opened,
  setOpened,
  merchant,
  toggleDialog,
}: {
  merchantContractAction: MerchantContractActionType;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  merchant: Merchant;
}) => {
  const merchantId = merchant.id;
  const { request, loading } = useRequest();

  const getDialogParamsByMerchantContractAction = () => {
    switch (merchantContractAction) {
      case MerchantContractActionType.SEND_MERCHANT_CONTRACT_REMINDER:
        return {
          titleTextId: 'SEND_MERCHANT_CONTRACT_REMINDER',
          actionDescriptionTextId: 'SEND_MERCHANT_CONTRACT_REMINDER_TEXT',
          confirmActionButtonTextId: 'SEND_REMINDER',
          onConfirmAction: async () => {
            await request(patchCreateSignatureReminderRequestForMerchantContract, { id: merchantId });
            toggleDialog();
          },
        };
      case MerchantContractActionType.SEND_NEW_MERCHANT_CONTRACT:
        return {
          titleTextId: 'SEND_NEW_MERCHANT_CONTRACT',
          actionDescriptionTextId: 'SEND_NEW_MERCHANT_CONTRACT_TEXT',
          confirmActionButtonTextId: 'SEND_NEW_MERCHANT_CONTRACT',
          onConfirmAction: async () => {
            await request(patchCreateSignatureRequestForMerchantContract, { id: merchantId });
            toggleDialog();
          },
        };
      default:
        return undefined;
    }
  };

  const DialogParamsByAction = getDialogParamsByMerchantContractAction();

  return (
    <NemuruDialog
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton variant={'contained'} loading={loading} onClick={DialogParamsByAction?.onConfirmAction}>
            <Text tId={DialogParamsByAction?.confirmActionButtonTextId} />
          </StandardButton>
        </>
      }
    >
      <Box mb={4}>
        <Font variant="h3" color="title">
          <Text tId={DialogParamsByAction?.titleTextId} />
        </Font>
      </Box>
      <Box>
        <Font variant="body2" color="textSecondary">
          <Text tId={DialogParamsByAction?.actionDescriptionTextId} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
